import { useSelector } from 'react-redux';
import { EmergencyFundData } from './EmergencyFund.meta';
import { selectCurrentClient } from '../../../../CommonSelectors/CommonAreaSelector';

interface Params {
  goalData: EmergencyFundData;
  yearsOptions: number[];
}

export const useEmergencyFund = ({ goalData, yearsOptions }: Params) => {
  const { Dob: primaryDob, PartnerDob: spouseDob } = useSelector(selectCurrentClient);

  const primaryYob = primaryDob ? new Date(primaryDob).getFullYear() : null;
  const spouseYob = spouseDob ? new Date(spouseDob).getFullYear() : null;

  return {
    ...goalData,
    fundedDateOptions: yearsOptions.map(year => ({
      label: year.toString(),
      value: year,
      rightLabel: primaryYob
        ? `Age ${year - primaryYob}${spouseYob ? `, Age ${year - spouseYob}` : ''}`
        : undefined,
    })),
  };
};
